import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";

const CareerObjectivesModal = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedObjectives, setSelectedObjectives] = useState([]);
  const [error, setError] = useState("");

  // Example options (replace with API if you have one)
  const careerOptions = [
    { id: "1", label: "Higher Compensation" },
    { id: "2", label: "Better Work-Life Balance" },
    { id: "3", label: "Relocation Opportunities" },
    { id: "4", label: "Good Environment" },
  ];

  // Load existing objectives
  useEffect(() => {
    if (!show) return;

    const objectives = store?.profileItem?.data?.career_objectives;
    if (!objectives) return;

    let parsed = [];

    if (Array.isArray(objectives)) {
      parsed = objectives;
    } else if (typeof objectives === "string") {
      try {
        parsed = JSON.parse(objectives);
      } catch {
        parsed = objectives.split(",");
      }
    }

    const mapped = careerOptions.filter((opt) => parsed.includes(opt.id));

    setSelectedObjectives(mapped);
  }, [show]);

  // Toggle selection
  const handleSelect = (obj) => {
    const exists = selectedObjectives.some((o) => o.id === obj.id);

    if (exists) {
      setSelectedObjectives(selectedObjectives.filter((o) => o.id !== obj.id));
    } else {
      setSelectedObjectives([...selectedObjectives, obj]);
    }

    setError("");
  };

  const handleSave = () => {
    if (selectedObjectives.length === 0) {
      setError("Please select at least one career objective");
      return;
    }

    const formData = new FormData();

    formData.append(
      "name",
      store?.profileItem?.data?.name ||
        store?.profileItem?.data?.full_name ||
        "",
    );

    selectedObjectives.map(obj => obj.id).forEach(id => {
      formData.append("career_objectives[]", id);
    });

    dispatch(updateProfile(formData));
  };

  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Career Objectives</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="checkbox-options">
          <div className="row">
            {careerOptions.map((obj) => (
              <div
                key={obj.id}
                className={`checkbox-option col-lg-6 ${
                  selectedObjectives.some((o) => o.id === obj.id)
                    ? "selected"
                    : ""
                }`}
                onClick={() => handleSelect(obj)}
              >
                <div className="contentwrap">
                  <input
                    type="checkbox"
                    checked={selectedObjectives.some((o) => o.id === obj.id)}
                    readOnly
                  />

                  <label className="checkbox-label">{obj.label}</label>
                </div>
              </div>
            ))}
          </div>
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || selectedObjectives.length === 0}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CareerObjectivesModal;
